module.exports = __webpack_public_path__ + "img/badge-most-appointment-keyvue-green.e36e6b36.png";